import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class AdminOverviewAdministator {
  @bindable
  private isPlm: boolean;
}
